<form [formGroup]="membershipForm" (ngSubmit)="onSubmit()">
  <!-- Subscription Name -->
  <div class="form-group mb-3">
    <label>Subscription Name</label>
    <input
      type="text"
      class="form-control"
      formControlName="name"
      placeholder="Enter subscription name"
    />
    <small
      class="text-danger"
      *ngIf="
        membershipForm.get('name')?.touched &&
        membershipForm.get('name')?.hasError('required')
      "
    >
      Subscription name is required.
    </small>
  </div>

  <!-- Description -->
  <div class="form-group mb-3">
    <label>Description</label>
    <textarea
      class="form-control"
      formControlName="description"
      placeholder="Enter description"
    ></textarea>
    <small
      class="text-danger"
      *ngIf="
        membershipForm.get('description')?.touched &&
        membershipForm.get('description')?.hasError('required')
      "
    >
      Description is required.
    </small>
  </div>

  <!-- Period -->
  <div class="form-group mb-3">
    <label>Period</label>
    <select class="form-control" formControlName="timing">
      <option value="" disabled selected>Select Period</option>
      <option *ngFor="let p of periods" [value]="p">{{ p | titlecase }}</option>
    </select>
    <small
      class="text-danger"
      *ngIf="
        membershipForm.get('timing')?.touched &&
        membershipForm.get('timing')?.hasError('required')
      "
    >
      Please select a period.
    </small>
  </div>

  <div class="form-group mb-3">
    <label>Duration</label>
    <input
      type="number"
      min="0"
      class="form-control"
      formControlName="duration"
      placeholder="Enter duration"
    />
  </div>

  <div class="form-group mb-3">
    <label>Features</label>
    <div
      *ngFor="let feature of features.controls; let i = index"
      class="d-flex mb-1"
    >
      <input type="text" [formControl]="feature" class="form-control me-2" />
      <button
        type="button"
        class="btn btn-danger btn-sm"
        (click)="removeFeature(i)"
      >
        Remove
      </button>
    </div>
    <div class="d-flex mt-2">
      <input
        #newFeature
        type="text"
        class="form-control me-2"
        placeholder="Add feature"
      />
      <button
        type="button"
        class="btn btn-primary btn-sm"
        style="min-width: 120px"
        (click)="addFeature(newFeature.value); newFeature.value = ''"
      >
        Add Feature
      </button>
    </div>
    <small class="text-danger" *ngIf="shouldShowFeatureError">
      At least one feature is required.
    </small>
  </div>

  <!-- Row: Price, VAT, Discount -->
  <div class="row mb-3">
    <div class="col-md-4">
      <label>Price</label>
      <input
        type="number"
        min="0"
        class="form-control"
        formControlName="price"
        placeholder="Enter price"
        [class.bg-light]="isEditMode"
      />
    </div>
    <div class="col-md-4">
      <label>VAT (%)</label>
      <input
        type="number"
        min="0"
        class="form-control"
        formControlName="vat"
        placeholder="Enter VAT"
        [class.bg-light]="isEditMode"
      />
    </div>
    <div class="col-md-4">
      <label>Discount (%)</label>
      <input
        type="number"
        min="0"
        class="form-control"
        formControlName="discount"
        placeholder="Enter discount"
        [class.bg-light]="isEditMode"
      />
    </div>
  </div>

  <!-- Row: Inclusive/Exclusive & Free Shipment -->
  <div class="row mb-3">
    <div class="col-md-6">
      <label>is VAT exclusive</label>

      <div class="form-check">
        <input
          class="form-check-input"
          type="radio"
          [value]="true"
          formControlName="isExclusive"
          id="isExclusive"
          [attr.disabled]="isEditMode ? true : null"
        />
        <label
          class="form-check-label"
          for="isExclusive"
          [class.text-muted]="isEditMode"
          >Yes</label
        >
      </div>
      <div class="form-check">
        <input
          class="form-check-input"
          type="radio"
          [value]="false"
          formControlName="isExclusive"
          id="isInclusive"
          [attr.disabled]="isEditMode ? true : null"
        />
        <label
          class="form-check-label"
          for="isInclusive"
          [class.text-muted]="isEditMode"
          >No</label
        >
      </div>
    </div>

    <div class="col-md-6">
      <label>Free Shipment</label>
      <div class="form-check">
        <input
          class="form-check-input"
          type="radio"
          [value]="true"
          formControlName="freeShipment"
          id="freeShipmentYes"
          [attr.disabled]="isEditMode ? true : null"
        />
        <label
          class="form-check-label"
          for="freeShipmentYes"
          [class.text-muted]="isEditMode"
          >Yes</label
        >
      </div>
      <div class="form-check">
        <input
          class="form-check-input"
          type="radio"
          [value]="false"
          formControlName="freeShipment"
          id="freeShipmentNo"
          [attr.disabled]="isEditMode ? true : null"
        />
        <label
          class="form-check-label"
          for="freeShipmentNo"
          [class.text-muted]="isEditMode"
          >No</label
        >
      </div>
    </div>
  </div>

  <!-- Free Product per Subscription -->
  <div class="form-group mb-3">
    <label>Free Product</label>
    <input
      type="number"
      min="0"
      class="form-control"
      formControlName="freeProduct"
      placeholder="Enter number of free products"
      [class.bg-light]="isEditMode"
    />
  </div>

  <!-- Submit -->
  <div class="text-right pt-3">
    <button type="submit" class="btn btn-primary" [disabled]="isSubmitting">
      <span *ngIf="isSubmitting">
        <i class="fa fa-spinner fa-spin"></i>
        {{ isEditMode ? "Updating..." : "Creating..." }}
      </span>
      <span *ngIf="!isSubmitting">
        {{ isEditMode ? "Update Membership" : "Save Membership" }}
      </span>
    </button>
  </div>
</form>
